<template>
  <v-card
    v-bind="$attrs"
    v-on="$listeners"
    class="rounded-lg"
    :color="color"
  >
    <v-row class="d-flex card">
      <v-col class="card-puesto d-flex justify-end">
        <div class="d-flex flex-column" style="width: 85%;">
          <div class="d-flex justify-center align-end mb-0 pb-0" cols="12" style="height: 50%">
            <h2 class="black--text">{{ puesto }}</h2>
          </div>
          <div class="mt-0 pt-0 mb-0 pb-0 d-flex justify-center align-end" cols="12" style="height: 50%;">
            <img src="@/assets/img/rectangulo.svg" :height="heightbar" :widthbar="widthbar" alt="">
          </div>
        </div>
      </v-col>
      <v-col class="card-puntos d-flex flex-column">
        <div class="pt-0 d-flex justify-end" style="height: 25%;">
          <div class="blue rounded-tr-lg height-2">
            <p class="ml-4 mr-3 mt-2 mb-2 white--text font-size-0-6">
              <span>{{ label }}</span></p>
          </div>
        </div>
        <div class="d-flex flex-column flex-nowrap" style="padding-left: 0; height: 75%;">
          <div class="d-flex justify-center align-end" style="height: 50%; padding-bottom: 0; padding-top: 8%;">
            <p class="black--text font-size-1-5 font-weight-6 text-align-center text-resp" style="height: 50%;">Tu
              puesto</p><br>
          </div>
          <div class="mt-0 pt-0 mb-0 pb-0" style="flex-grow: 1" v-if="usuarios">
            <p class="grey--text font-size-0-6 mb-0 pb-0 text-align-center">Entre
              {{ usuarios }} usuarios</p>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'CardPuesto',
  inheritAttrs: false,
  props: {
    label: String,
    heightbar: String,
    widthbar: String,
    color: String,
    puesto: {
      type: [Number, String],
      default: 0
    },
    usuarios: {
      type: [Number, String],
      default: ''
    }
  }
}
</script>

<style scoped>
.box-shadow-0-7 {
  box-shadow: 0 4px 16px rgba(0, 0, 0, .07);
}

.card {
  margin: 0;
  height: 100%;
  width: 100%;
  padding-bottom: 0;
}

.card-puntos {
  flex-basis: 50%;
  flex-grow: 0;
  padding: 0;
  height: 100%;
  bottom: 0;
}

.card-puesto {
  flex-basis: 50%;
  flex-grow: 0;
  height: 100%;
  bottom: 0;
  padding-bottom: 0;
  margin-top: auto;
}

@media (max-width: 980px) and (min-width: 560px) {
  .text-resp {
    font-size: 20px;
  }
}
</style>
